class SideDrawer extends HTMLElement {
  constructor() {
    super();
    let self = this;
    let mainDiv = document.querySelector('main');
    this.target = self.getAttribute('data-target');
    this.openTrigger = document.querySelectorAll('[data-sidebar-trigger][data-target="' + this.target + '"]');
    this.sideBarContainer = this.parentElement;
    this.sideBarContent = this;
    this.close = this.querySelector('.side-close');
    

    this.size = window.screen.width;

    /*
    if (this.size > 1023) {
      this.querySelector('.videobox-desktop').classList.remove("hidden");
      this.querySelector('.videobox-mobile').classList.add("hidden");
      this.querySelector('.videobox-mobile').style.height = '0';      
    } else {
      this.querySelector('.videobox-desktop').classList.add("hidden");
      this.querySelector('.videobox-desktop').style.height = '0';
      this.querySelector('.videobox-mobile').classList.remove("hidden");
    }
    */

    if (self.sideBarContent.classList.contains('mobile-only') && this.size > 1024) {
      return;
    } else if (self.sideBarContent.classList.contains('desktop-only') && this.size < 1024) {
      return;
    }

    /* Use append to the main div so that it appears prominently */

    this.openTrigger.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.stopPropagation();
        self.sideBarContainer.classList.add("sidebar-visible");
        self.sideBarContainer.classList.remove("hidden");
        mainDiv.append(this.sideBarContainer);
        self.querySelector('video')?.play()
      });
    });

    this.close.addEventListener('click', function(event) {
      event.stopPropagation();
      self.sideBarContainer.classList.remove("sidebar-visible");
      self.sideBarContainer.classList.add("hidden");
       if (self.size > 1023) {
         self.querySelector('.videobox-desktop').firstElementChild.pause();
       }else{
         self.querySelector('.videobox-mobile').firstElementChild.pause();
       }
    });

    document.addEventListener('click', function(event) {
      if (!self.sideBarContent.contains(event.target) && !Array.from(self.openTrigger).some(trigger => trigger.contains(event.target))) {
        self.sideBarContainer.classList.remove("sidebar-visible");
        self.sideBarContainer.classList.add("hidden");
      if (self.size > 1023) {
         self.querySelector('.videobox-desktop').firstElementChild.pause();
       }else{
         self.querySelector('.videobox-mobile').firstElementChild.pause();
       }
      }
    });

  }
}

customElements.define('side-drawer', SideDrawer);
